// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___2RitH","hide":"style__hide___3iVyJ","list":"style__list___2Usy5","search":"style__search___1QEnM","searchBar":"style__searchBar___1ojaD","toolButton":"style__toolButton___381Qk","table":"style__table___3vdC4","title":"style__title___vvkfr","createButton":"style__createButton___15qBB","buttonWrapper":"style__buttonWrapper___1kD3B","button":"style__button___12lTW","add":"style__add___2Znl2","showMore":"style__showMore___3PTxc","noResult":"style__noResult___1Ytoc"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/style.scss
// module id = 1703
// module chunks = 0